export default "__VITE_ASSET__tlPVKqKR__"